"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "executeInProcess", {
    enumerable: true,
    get: function() {
        return executeInProcess;
    }
});
const _config = require("@lage-run/config");
const _targetgraph = require("@lage-run/target-graph");
const _path = /*#__PURE__*/ _interop_require_default(require("path"));
const _fs = /*#__PURE__*/ _interop_require_default(require("fs"));
const _workspacetools = require("workspace-tools");
const _filterArgsForTasks = require("../run/filterArgsForTasks.js");
const _expandTargetDefinition = require("./expandTargetDefinition.js");
const _runners = require("@lage-run/runners");
const _runnerPickerOptions = require("../../runnerPickerOptions.js");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Parses the package and task from the command as quickly as possible:
 *
 * 1. if cwd overridden in args, use it to read the package.json directly
 * 2. if cwd not overridden and root is not cwd, use the cwd to read the package.json directly
 * 3. if root is cwd, assume the task is global
 *
 * @param options
 * @param command
 * @returns
 */ function parsePackageInfoFromArgs(root, cwd, packageName, task) {
    if (packageName && task) {
        const packageInfos = (0, _workspacetools.getPackageInfos)(root);
        const info = packageInfos[packageName];
        return {
            info,
            task,
            isGlobal: false
        };
    }
    if (cwd) {
        const packageJsonPath = _path.default.join(cwd, "package.json");
        const packageJson = JSON.parse(_fs.default.readFileSync(packageJsonPath, "utf-8"));
        return {
            info: {
                ...packageJson,
                packageJsonPath
            },
            task,
            isGlobal: false
        };
    }
    if (root !== process.cwd()) {
        const packageJsonPath = _path.default.join(process.cwd(), "package.json");
        if (_fs.default.existsSync(packageJsonPath)) {
            const packageJson = JSON.parse(_fs.default.readFileSync(packageJsonPath, "utf-8"));
            return {
                info: {
                    ...packageJson,
                    packageJsonPath
                },
                task,
                isGlobal: false
            };
        }
    }
    const packageJsonPath = _path.default.join(root, "package.json");
    const packageJson = JSON.parse(_fs.default.readFileSync(packageJsonPath, "utf-8"));
    return {
        info: {
            ...packageJson,
            packageJsonPath
        },
        task,
        isGlobal: true
    };
}
async function executeInProcess({ cwd, args, nodeArg, logger }) {
    const root = (0, _workspacetools.getWorkspaceRoot)(process.cwd());
    const config = await (0, _config.getConfig)(root);
    const { pipeline } = config;
    const taskArg = args?.length === 1 ? args?.[0] : args?.[1];
    const packageName = args?.length ?? 0 > 1 ? args?.[0] : undefined;
    if (!taskArg) {
        throw new Error("No task provided");
    }
    const { info, task, isGlobal } = parsePackageInfoFromArgs(root, cwd, packageName, taskArg);
    const packageInfos = {
        [info.name]: info
    };
    const resolve = ()=>{
        return _path.default.dirname(info.packageJsonPath).replace(/\\/g, "/");
    };
    const { taskArgs } = (0, _filterArgsForTasks.filterArgsForTasks)(args ?? []);
    const factory = new _targetgraph.TargetFactory({
        root,
        resolve,
        packageInfos
    });
    const definition = (0, _expandTargetDefinition.expandTargetDefinition)(isGlobal ? undefined : info.name, task, pipeline, config.cacheOptions.outputGlob ?? []);
    const target = isGlobal ? factory.createGlobalTarget(task, definition) : factory.createPackageTarget(info.name, task, definition);
    const pickerOptions = (0, _runnerPickerOptions.runnerPickerOptions)(nodeArg, config.npmClient, taskArgs);
    const runnerPicker = new _runners.TargetRunnerPicker(pickerOptions);
    const runner = await runnerPicker.pick(target);
    if (await runner.shouldRun(target)) {
        logger.info("Running target", {
            target
        });
        try {
            await runner.run({
                target,
                weight: 1,
                abortSignal: new AbortController().signal
            });
            logger.info("Finished", {
                target
            });
        } catch (result) {
            process.exitCode = 1;
            if (typeof result === "object" && result !== null && "exitCode" in result) {
                if (typeof result.exitCode === "number" && result.exitCode !== 0) {
                    process.exitCode = result.exitCode;
                }
            }
            if (typeof result === "object" && result !== null && "error" in result) {
                logger.error(`Failed`, {
                    target,
                    error: result.error
                });
                return;
            }
            logger.error(`Failed`, {
                target,
                error: result
            });
        }
    }
}
